import { render } from "./CurrentEvent.vue?vue&type=template&id=2e4b2a0c&scoped=true"
import script from "./CurrentEvent.js?vue&type=script&lang=js"
export * from "./CurrentEvent.js?vue&type=script&lang=js"

import "./CurrentEvent.scss?vue&type=style&index=0&id=2e4b2a0c&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4b2a0c"]])

export default __exports__